import {ComponentPortal} from '@angular/cdk/portal';
import {Directive, OnInit} from '@angular/core';

import {InternalNodeSidebarSubTabs, internalNodeSidebarTabs} from './portals';

@Directive()
export abstract class InternalNodeSidebarBaseTab implements OnInit {
  public tabPortal: ComponentPortal<any>;
  public selectedTab: InternalNodeSidebarSubTabs;

  public readonly SUB_TABS = InternalNodeSidebarSubTabs;

  ngOnInit() {
    this.onTabChange();
  }

  public onTabChange() {
    if (this.selectedTab) {
      this.tabPortal = this.getComponentPortal(this.selectedTab!);
    }
  }

  private getComponentPortal(tab: InternalNodeSidebarSubTabs) {
    return new ComponentPortal(internalNodeSidebarTabs[tab] as any);
  }
}
